import React from 'react';
import { Grid, Button, Typography } from '@material-ui/core';
import css from './index.module.scss';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

export default function NoOrder({ callback, img = '', heading, subHeading, isFeedback = false }) {
  return (
    <Grid className={css.noOrderContainer}>
      <Grid>
        <img src={img} alt="" />
      </Grid>
      <Grid className={css.text}>
        <Typography>{heading}</Typography>
      </Grid>
      <Grid className={css.textDesc}>
        <Typography variant="body1">{subHeading}</Typography>
      </Grid>
      <Grid>
        <Button
          variant="contained"
          color="primary"
          size="large"
          className={classNames(css.primaryButton, { [css.customStyle]: isFeedback })}
          onClick={callback}
        >
          <FormattedMessage id="explore_menu" defaultMessage="Explore Menu" />
        </Button>
      </Grid>
    </Grid>
  );
}
